<template>
  <div class="detail">
    <div class="detail__header">
      <DetailHeader :unit="unit" :bulk="false" />
    </div>
    <div class="detail__settings">
      <div class="detail__settings__wrapper">
        <DetailMap :unit="unit" v-if="unit.lat"/>
        <DetailSettings :unit="unit" :sensors="unit.sensors"
                        @dirtyBatch="(value) => dirtyBatch = value" v-if="refreshUnitComponent" />

        <AdvancedDynamicCalibration
          v-if="unit.sensors.some(sensor => sensor.name.toLowerCase() === 'moisture') &&
            unit.batch &&
            unit.batch.type && unit.batch.type.properties && !dirtyBatch"
          :batch="unit.batch"
          :sensor="unit.sensors.find(sensor => sensor.name.toLowerCase() === 'moisture')"
          :device="unit"
          :blockedMode="dirtyBatch"
          @changedBatch="refreshUnit"
        />

        <DynamicSensingTiming
           v-if="unit.version.hasDynamicSensing"
          :device="unit"
        />
      </div>
    </div>
    <div class="detail__charts">
      <div class="detail__charts__wrapper">
        <DetailEventChartPanel :loadedData="eventData" key="{{ $t('detail.events_header') }}" sensor="" :unit="unit" isSensor="false"/>
      </div>
      <div class="detail__charts__wrapper">
        <DetailChartPanel v-for="sensor in unit.sensors" :loadedData="chartData" :key="sensor.id" :sensor="sensor" :unit="unit" isSensor="true"/>
      </div>
    </div>
  </div>
</template>
<script>
  import {tentacles} from '@/config/tentacles';
  import DetailHeader from '@/views/detail/DetailHeader.vue';
  import DetailSettings from '@/views/detail/DetailSettings.vue';
  import DetailMap from '@/views/detail/DetailMap.vue';
  import DetailChartPanel from '@/views/detail/DetailChartPanel.vue';
  import DetailEventChartPanel from '@/views/detail/DetailEventChartPanel.vue';
  import AdvancedDynamicCalibration from '@/views/detail/AdvancedDynamicCalibration.vue';
  import DynamicSensingTiming from '@/views/detail/DynamicSensingTiming.vue';

  export default {
  name: 'Detail',
  components: {
    AdvancedDynamicCalibration,
    DynamicSensingTiming,
    DetailHeader,
    DetailSettings,
    DetailMap,
    DetailChartPanel,
    DetailEventChartPanel,
  },
  data() {
    return {
      dirtyBatch: false,
      chartData: [],
      eventData: [],
      refreshUnitComponent: true,
    };
  },
  computed: {
    tentacles() {
      return tentacles;
    },
    sensors() {
      const tentacleType = this.tentacles.find(tentacle => tentacle.id === this.unit.id);
      return tentacleType ? tentacleType.sensors : [];
    },
    unit() {
      return this.$store.getters['tentacle/unitById'](parseInt(this.$route.params.id, 10));
    },
  },
  created() {
    for (let i = 0; i < this.sensors.length; i += 1) {
      this.chartData.push({
        id: '',
        name: '',
        unit: '',
        values: null,
      });
    }
  },
  mounted() {
    this.setChartData(this.getDefaultRangeDate(), this.getDateFromToday(0, 0, 0));
    this.setEventData(this.getDefaultRangeDate(), this.getDateFromToday(0, 0, 0));
  },
  watch: { // because of page reload, when unit is not ready, wait for unit and get data
    unit(newUnit, oldUnit) {
      if (newUnit.id) {
        this.setChartData(this.getDefaultRangeDate(), this.getDateFromToday(0, 0, 0));
      }
    },
  },
  methods: {
    getDefaultRangeDate() {
      return this.getDateFromToday(0, 0, -1);
    },
    refreshUnit() {
      this.refreshUnitComponent = false;
      this.$nextTick(() => {
        this.refreshUnitComponent = true;
      });
    },
    getDateFromToday(year, month, day) {
      return `${new Date().getFullYear() + year}-${new Date().getMonth() + 1 + month}-${new Date().getDate() + day}`;
    },
    setChartData(fromDate, toDate) {
      let filter = [];
      for (let i = 0; i < this.unit.sensors.length; i += 1) {
        if (this.unit.sensors[i].id !== null) {
          filter.push({ id: this.unit.sensors[i].id, from: fromDate, to: toDate });
        }
      }
      const data = {
        filter: filter,
        tentacle: this.unit.id
      };
      this.$store.dispatch('tentacle/setMeasurement', data).then((resolve) => {
        let data = [];
        if (resolve.data[0]) {
          data = resolve.data;
        }
        this.chartData = data;
      });
    },
    setEventData(fromDate, toDate) {
      let filter = [];
      filter.push({ from: fromDate, to: toDate });

      const data = {
        filter: filter,
        tentacle: this.unit.id
      };
      this.$store.dispatch('tentacle/setEvent', data).then((resolve) => {
        let data = [];
        if (resolve.data[0]) {
          data = resolve.data;
        }
        this.eventData = data;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.detail {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    grid-column-gap: 4rem;
    @media only screen and (max-width: 1400px) {
        width: 100%;
        grid-template-columns: 1fr;
        padding-bottom: 5em;
    }

    &__header {
        grid-column: 1/4;
        @media only screen and (max-width: 1400px) {
            grid-column: 1/1;
        }
    }

    &__settings {
        grid-column: 1/2;
        @media only screen and (max-width: 1400px) {
            margin-top: 2em;
            width: 100%;
            grid-column: 1/1;
        }
    }

    &__charts {
        width: 100%;
        grid-column: 2/4;

        &__wrapper {
            padding-right: 8rem;
        }
        @media only screen and (max-width: 1400px) {
            width: 100%;
            grid-column: 1/1;
            &__wrapper {
                padding-right: 0;
            }
        }
    }
}

</style>
